import { Link } from "react-router-dom";
import { PaginatedTable } from "../components/PaginatedTable";
import React from "react";
import { loadCompaniesPage } from "../api/Company";
import { Company } from "../models/Company";
import { Breadcrumb } from "../components/Breadcrumb";

const TABLE_COLUMNS = [
  {
    id: "name",
    name: "Name",
    selector: (company: Company) => company.name,
    grow: 0.9,
    sortable: true,
  },
  {
    name: "",
    cell: (company: Company) => (
      <Link to={`/companies/${company.id}`} className="btn btn-primary">
        <i className="fa-solid fa-file-pen"></i>
      </Link>
    ),
    grow: 0.1,
    sortable: false,
  },
];

export const Companies = () => {
  return (
    <>
      <Breadcrumb items={[{ text: "Companies", link: "/companies" }]} />
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-header pb-0">
              <div className="float-end">
                <Link to="/companies/new" className="btn btn-primary">
                  New Company <i className="fa-solid fa-circle-plus"></i>
                </Link>
              </div>
              <h5 className="card-title mb-0">Companies</h5>
            </div>
            <div className="card-body">
              <PaginatedTable
                columns={TABLE_COLUMNS}
                loadPage={loadCompaniesPage}
                filterable
                defaultSortField="name"
                defaultSortAsc
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
